<template>
  <div>
    <div
      class="form-fw__header"
      :class="{ 'form-fw__header--shadow': shadow }"
    >
      <header>
        <v-layout align-center justify-start row>
          <v-flex xs2 md3>
            <v-btn class="mx-0" flat icon @click="prevPage">
              <v-icon color="gray-6">arrow_back</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs8 md6>
            <div class="text-xs-center">
              <h1 class="form-fw__header__title">
                {{
                  kind === 'editar'
                    ? $t(`${namespace}.editCompany`)
                    : $t(`${namespace}.addCompany`)
                }}
              </h1>
            </div>
          </v-flex>

          <v-flex xs2 md3 />
        </v-layout>
      </header>

      <transition name="fade">
        <v-progress-linear
          v-if="status === isLoading"
          color="accent"
          class="pa-0 ma-0"
          height="3"
          indeterminate
        />
      </transition>
    </div>

    <transition name="fade">
      <div v-if="showErrorMessage" class="form-fw__header__message form-fw__header__message--error">
        <v-icon>warning</v-icon>
        {{ $t(`${namespace}.errorMessage`) }}
      </div>
    </transition>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { goBack } from '@/utils/functions'

export default {
  name: 'Header',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    },
    showErrorMessage: {
      type: Boolean,
      defalt: false
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.CompanyDataPage.header',
      shadow: false
    }
  },
  methods: {
    prevPage () {
      if (this.kind === 'cadastrar') {
        this.$router.push({
          name: 'Company',
          query: { tab: 'company' }
        })

        return
      }

      goBack()
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  watch: {
    showErrorMessage () {
      window.setTimeout(() => { this.$emit('hideErrorMessage') }, 4000)
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
